import { render, staticRenderFns } from "./UpdateHighlightVideo.vue?vue&type=template&id=43905fac&"
import script from "./UpdateHighlightVideo.vue?vue&type=script&lang=js&"
export * from "./UpdateHighlightVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports